import CompatsWidgetSticky from '../../../../components/compats-widget/sticky/compats-widget-sticky-container.desktop';
import compatsWidgetSticky from './compats-widget-sticky';

export default compatsWidgetSticky(CompatsWidgetSticky);
